import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["placeholder", "value", "disabled"]
const _hoisted_2 = ["placeholder", "value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-icon", { shake: _ctx.shake, error: _ctx.error, success: _ctx.success, edit: _ctx.state === 'EDITING' }])
  }, [
    (!_ctx.mask)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "text",
          class: "input-field",
          placeholder: _ctx.placeholder,
          value: _ctx.modelValue,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args))),
          onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args))),
          onFocusout: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.focusOut && _ctx.focusOut(...args))),
          onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.keydown && _ctx.keydown(...args))),
          disabled: _ctx.disabled,
          ref: "inputElement"
        }, null, 40, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.mask)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          type: "text",
          class: "input-field",
          placeholder: _ctx.placeholder,
          value: _ctx.modelValue,
          onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args))),
          onFocus: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args))),
          onFocusout: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.focusOut && _ctx.focusOut(...args))),
          onKeydown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.keydown && _ctx.keydown(...args))),
          disabled: _ctx.disabled,
          ref: "inputElement"
        }, null, 40, _hoisted_2)), [
          [_directive_mask, _ctx.mask]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "icon-wrap",
      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.enter && _ctx.enter(...args)))
    }, [...(_cache[9] || (_cache[9] = [
      _createElementVNode("svg", {
        width: "20",
        height: "16",
        viewBox: "0 0 20 16",
        fill: "none",
        class: "icon"
      }, [
        _createElementVNode("path", {
          d: "M4.842 13.784L1.825 10.241H1.825C0.724919 8.94951 0.724919 7.05049 1.825 5.759L4.842 2.216V2.216C5.49859 1.44435 6.46081 0.9998 7.474 1H15.543V1C17.4522 1 19 2.54775 19 4.457C19 4.457 19 4.457 19 4.457V11.543V11.543C19 13.4523 17.4522 15 15.543 15H7.474V15C6.46081 15.0002 5.4986 14.5556 4.842 13.784V13.784Z",
          stroke: "currentColor",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        _createElementVNode("path", {
          d: "M13.882 6.51294L10.907 9.48694L9.11801 7.69994",
          stroke: "currentColor",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)
    ]))])
  ], 2))
}